document.addEventListener("cart:updated", async function () {
  if (!window.theme.settings.engravingProductId) {
    return;
  }

  const cartResponse = await fetch(`${window.routes.cart_url}.json`);
  const cart = await cartResponse.json();
  const cartElement =
    document.querySelector("cart-notification") || document.querySelector("cart-drawer");

  let engravedItemQty = 0;
  let engravingItem = null;

  cart.items.forEach((item) => {
    if (item.variant_id == window.theme.settings.engravingProductId) {
      engravingItem = item;
    }

    if (item.properties[window.cartStrings.engraving]) {
      engravedItemQty += item.quantity;
    }
  });

  if ((engravingItem && engravingItem.quantity == engravedItemQty) || (engravedItemQty == 0 && !engravingItem)) {
    return;
  }

  const numToAdd = engravedItemQty;

  let response = null;

  if (engravingItem) {
    response = await fetch(`${window.routes.cart_change_url}.js`, {
      body: JSON.stringify({
        id: engravingItem.key,
        quantity: numToAdd,
        sections: cartElement.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });
  } else {
    const formData = {
      items: [
        {
          id: window.theme.settings.engravingProductId,
          quantity: numToAdd,
        },
      ],
      sections: cartElement.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    };

    response = await fetch(`${window.routes.cart_add_url}.js`, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify(formData),
    });
  }

  if (response.status != "200") {
    return;
  }

  const responseJson = await response.json();

  setTimeout(() => {
    cartElement.renderContents(responseJson, true);
  }, 400);
});

class EngravingInput extends HTMLElement {
  constructor() {
    super();
    this.updateAttribute.bind(this);
    this.createAttribute.bind(this);
  }

  connectedCallback() {
    this.dom = {
      input: this.querySelector("#engraving"),
      form: document.querySelector('.product-form [action="/cart/add"]'),
    };

    this.addEventListeners();
  }

  addEventListeners() {
    this.dom.input.addEventListener("input", (event) => this.updateAttribute(event.target.value));
  }

  updateAttribute(value) {
    if (this.dom.attribute) {
      if (!value) {
        this.dom.attribute.remove();
        this.dom.attribute = null;
        return;
      }

      this.dom.attribute.value = value;
      return;
    }

    this.createAttribute(value);
  }

  createAttribute(value) {
    const attribute = document.createElement("input");
    attribute.type = "hidden";
    attribute.name = `properties[${window.cartStrings.engraving}]`;
    attribute.value = value;

    this.dom.form.appendChild(attribute);
    this.dom.attribute = attribute;
  }
}

if (!customElements.get("engraving-input")) {
  customElements.define("engraving-input", EngravingInput);
}
